import { render, staticRenderFns } from "./MassCommunication.vue?vue&type=template&id=66833632&"
import script from "./MassCommunication.vue?vue&type=script&lang=js&"
export * from "./MassCommunication.vue?vue&type=script&lang=js&"
import style0 from "./MassCommunication.vue?vue&type=style&index=0&id=66833632&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports